import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue } from "bootstrap-vue";
import vSelect from "vue-select";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Toasted from "vue-toasted";
import { Carousel, Slide } from 'vue-carousel';
Vue.config.productionTip = false
Vue.use(VueTelInput);
Vue.use(BootstrapVue);
Vue.component("v-select", vSelect);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("carousel", Carousel);
Vue.use(Toasted, {
	iconPack: "fontawesome",
	singleton: true,
});
library.add(faUserSecret);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
